import { render, staticRenderFns } from "./MsgSet.vue?vue&type=template&id=38636ac4&scoped=true&"
import script from "./MsgSet.vue?vue&type=script&lang=js&"
export * from "./MsgSet.vue?vue&type=script&lang=js&"
import style0 from "./MsgSet.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MsgSet.vue?vue&type=style&index=1&id=38636ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38636ac4",
  null
  
)

export default component.exports